import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/axios'
import { API_ROUTES } from '@/constants/routes'
import { useAuthStore } from '@/stores/useAuthStore'

export interface VolumeTier {
    id: number
    price_config: number
    min_millares: number
    price_per_millar: string
}

export interface PriceConfig {
    id: number
    material: number
    material_name: string
    size: number
    size_name: string
    price_per_millar: string
    min_millares: number
    is_active: boolean
    tiers: VolumeTier[]
    allow_half_millar: boolean
}

const KEYS = {
    all: ['prices'] as const,
    list: (material?: number, size?: number) => [...KEYS.all, 'list', material, size] as const,
}

export function usePrices(material?: number, size?: number) {
    const { isLogged } = useAuthStore()
    return useQuery({
        queryKey: KEYS.list(material, size),
        queryFn: async () => {
            const params = new URLSearchParams()
            if (material) params.set('material', String(material))
            if (size) params.set('size', String(size))
            const { data } = await api.get<{ results: PriceConfig[] } | PriceConfig[]>(`${API_ROUTES.prices}?${params}`)
            return Array.isArray(data) ? data : data.results
        },
        enabled: isLogged && !!material,
        placeholderData: (prev) => prev,
        staleTime: 5 * 60 * 1000,
    })
}
